import autoText from 'ui/autotext/street.js';
import AbstractSelect from './abstract.js';

export default class StreetSelect extends AbstractSelect {
    init(elements = {}) {
        super.init(elements);

        this.at = autoText.init(
            this.element,
            {
                type: 'street',
                cantBeEmpty: true,
                requireData: true,
                cityRequired: true,
                paged: true,
            },
            {
                onselect: ::this._onSelect,
                emptyselect: ::this._onDropSelect,
                ondrop: ::this._onDropSelect,
                beforeload: ::this._onBeforeLoad,
                open: ::this._onOpen,
            }
        );

        if (!this.at) {
            throw new Error('Street autotext init error');
        }

        this.element.on('keyup change', () => {
            this.error = false;
        });

        console.log('Street select init complete.');
    }

    drop() {
        super.drop();
        this.city = null;
    }

    set city(value) {
        this.at.options.city = value || null;
    }
}
